<template id="template">
  <div style="">
    <b-card no-body>
      <b-tabs pills card class="tabPanel">



        <b-tab title="Παράδοση Βιβλίου">
          <div class="container-fluid" id="deliveryContainer">
            <component :is="currentView" @toggleView="toggleComponent"></component>
          </div>
        </b-tab>




        <b-tab title="Εκδότες - Βιβλία" v-if="isDistributionPoint">
          <div class="container" style="margin-bottom: 10px;">
            <b-card no-body class="text-center" style="font-size: 15px; padding: 1em;">
              <i>Στην ακόλουθη λίστα περιλαμβάνονται οι Εκδότες που έχουν επιλέξει το παρόν σημείο διανομής ως τόπο παράδοσης των συγγραμμάτων τους.
                Επιλέξτε έναν Εκδότη για να προβάλλετε τη λίστα των βιβλίων του καθώς και την οριζόμενη διαθεσιμότητα και τις παραδόσεις κάθε βιβλίου από το σημείο διανομής.</i>
            </b-card>
          </div>
          <publisher-component></publisher-component>
        </b-tab>



        <b-tab title="Αναφορές">
          <div class="container" style="margin-bottom: 10px;">
            <b-card no-body class="text-center" style="font-size: 15px; padding: 1em;">
              <i>Επιλέξτε τύπο αναφοράς πατώντας το αντίστοιχο κουμπί</i>
            </b-card>
          </div>
          <reports-tab-component></reports-tab-component>
        </b-tab>



        <b-tab title="Τμήματα" v-if="isSecretariat">
          <div class="container" style="margin-bottom: 10px;">
            <b-card no-body class="text-center" style="font-size: 15px; padding: 1em;">
              <i>Επιλέξτε τα Τμήματα στα οποία θέλετε να διανείμετε τα διαθέσιμα αποθέματα βιβλίων</i>
            </b-card>
          </div>
          <departments-tab-component></departments-tab-component>
        </b-tab>



        <b-tab title="Διαθεσιμότητα Βιβλίων" v-if="isSecretariat">
          <div class="container" style="margin-bottom: 10px;">
            <b-card no-body class="text-center" style="font-size: 15px; padding: 1em;">
              <i>Ενημερώστε τη διαθεσιμότητα των βιβλίων που έχετε. <br />Τα βιβλία μπορούν να παραδοθούν σε φοιτητές των τμημάτων που εξυπηρετεί αυτό το σημείο διανομής αν υπάρχει δηλωμένη διαθεσιμότητα.</i>
            </b-card>
          </div>
          <availability-tab-component></availability-tab-component>
        </b-tab>

      </b-tabs>
    </b-card>
  </div>
</template>

<script>

  import DeliveryFormComponent from './BookDeliveryTabComponents/DeliveryFormComponent.vue';
  import BookListComponent from './BookDeliveryTabComponents/BookListComponent.vue';
  import ReportsTabComponent from './ReportsTabComponents/ReportsTabComponent.vue';
  import PublisherFormComponent from './PublisherComponents/PublisherFormComponent.vue';
  import DepartmentsTabComponent from './DepartmentsTabComponents/SelectDepartmentComponent.vue';
  import AvailabilityTabComponent from './AvailabilityTabComponents/SearchAvailabilityComponent.vue';
  import {GlobalEudoxusBus} from "../js/DistributionRequestService";

  export default {
    template: '#template',
    data() {
      return {
        currentView: 'deliveryFormComponent',
        isDistributionPoint: true,
        isSecretariat: true
      }
    },
    components: {
      'deliveryFormComponent': DeliveryFormComponent,
      'bookListComponent': BookListComponent,
      'publisherComponent': PublisherFormComponent,
      'reportsTabComponent': ReportsTabComponent,
      'departmentsTabComponent': DepartmentsTabComponent,
      'availabilityTabComponent': AvailabilityTabComponent
    },
    methods: {
      toggleComponent(componentTag) {
        this.currentView = componentTag;
      },
      toggleDistComponent(flag) {
        if (flag) {
          this.isDistributionPoint = true;
          this.isSecretariat = false;
          GlobalEudoxusBus.$emit('publishSetupEvent', true);
        } else {
          this.isDistributionPoint = false;
          this.isSecretariat = true;
        }
      }
    },
    created() {
      GlobalEudoxusBus.$on('distributionTabsLayoutSetup', flag => {
        this.toggleDistComponent(flag);
      });
    }
  }
</script>

<style scoped>
  #template {
    height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/DistributionPointsTabPanel.vue